import React from "react";
import Cards from "../components/Cards/Cards";

function App() {
  return (
    <div className="app">
      <Cards />
    </div>
  );
}

export default App;
